import { ReactSVG } from "react-svg";

const WidgetIconFour = ({ iconProp, cursorProp = "pointer", handleOnClickProp, widthIconProp, heightIconProp }) => {
  return (
    <ReactSVG
      src={iconProp}
      style={{ cursor: cursorProp }}
      onClick={handleOnClickProp}
      beforeInjection={(svg) => {
        svg.setAttribute("width", widthIconProp);
        svg.setAttribute("height", heightIconProp);
        svg.setAttribute("style", "overflow: visible;");
      }}
    />
  );
};

export default WidgetIconFour;
